module.exports = __webpack_public_path__ + "img/isolation-ap.dd0e04a8.png";